<div [ngClass]="class === undefined ?'buttonBarContainer':class">
  <ng-container *ngFor="let item of buttons" >
    <input *ngIf="item.type=='file'" type="file" [name]="item.name"  (change)="buttonItemClick($event)"/>
    <button mat-raised-button *ngIf="item.type!='file'" type="button" 
        isIconButton="true" isRoundButton="true"
        [name]="item.name" [color]="item.color" 
        (click)="buttonItemClick($event)">
      <mat-icon *ngIf="item.icon">{{item.icon}}</mat-icon>
      {{item.label | translate}}
    </button>
  </ng-container>
  </div>